/* globals adpageHeading */
require([
  'jquery',
  'mojo-analytics',
], function (
  $,
  MojoAnalytics
) {


  var OVERLAY_CLASS_ON_BODY = 'has--fixed-overlay',

    r = {
      $formOverlays: $('.form-overlay'),
      $loginSection: $('#overlayLogin'),
      $overlayClose: $('.form-overlay-close'),
      $loginTrigger: $('.js-login-trigger'),
      $htmlBody: $('html, body'),
      $googleLogin: $('.login-google'),
      $facebookLogin: $('.login-facebook'),
    };

  var isOverlayVisible = false

  ;

  var cta = $('#cta-text').html();
  MojoAnalytics.sendEvent({
    eventName: 'Viewed Logout Page',
    eventData: {
      cta_text: cta ? cta : null,
      offer_heading: adpageHeading ? adpageHeading : null,
    },
  });

  $('.advert-cta').click(function () {
    var cta2 = $('#cta-text').html();
    MojoAnalytics.sendEvent({
      eventName: 'Clicked Logout CTA',
      eventData: {
        cta_text: cta2 ? cta2 : null,
        offer_heading: adpageHeading ? adpageHeading : null,
      },
    });
  });

  function handleOverlay (overlayElem) {
    r.$formOverlays.hide();

    overlayElem.fadeIn(200);

    isOverlayVisible = true;

    r.$htmlBody.addClass(OVERLAY_CLASS_ON_BODY);
  }

  function handleLoginSection (e) {
    e.preventDefault();
    handleOverlay(r.$loginSection);
  }

  function handleOverlayCloseViaEsc (e) {
    if (!isOverlayVisible) {
      return;
    }

    if (e.keyCode === 27) {
      handleOverlayClose();
    }
  }

  function handleOverlayClose (e) {
    if (e) {
      e.preventDefault();
    }

    r.$formOverlays.hide();

    isOverlayVisible = false;

    r.$htmlBody.removeClass(OVERLAY_CLASS_ON_BODY);
  }

  function handleSocialLoginClick (signInMethod, signInType) {
    MojoAnalytics.sendEvent({
      eventName: 'Attempted Sign In',
      eventData: {
        signin_method: signInMethod,
        signin_intent: signInType,
      },
    });
  }

  function bindAll () {

    /* init login section overlay */
    r.$loginTrigger.on('click', handleLoginSection);

    /* enable closing overlay by clicking on cross */
    r.$overlayClose.on('click', handleOverlayClose);

    r.$googleLogin.on('click', function () {
      handleSocialLoginClick('google', $(this).data('signinType'));
    });

    r.$facebookLogin.on('click', function () {
      handleSocialLoginClick('facebook', $(this).data('signinType'));
    });

    $(document).on('keydown', handleOverlayCloseViaEsc);
  }

  bindAll();
});

define("logout", function(){});

